/**
 * 11332 上报检查
 * @module report/11332_check_error
 * 解决三个痛点：
 *     1、错报
 *     2、重复报
 *     3、漏报
 * errType：
 *     0 ： ok
 *     1 ： 错报
 *     2 ： 数值重复
 */

 import env from 'common/env.js';
 import xhrCallCgi from 'common/ajaxcall.js';

 let exportData;
 if(!env.isCSR) {
    (function(win, doc) {
        "use strict";


        var reportHistoryList = []; // 保存所有上报记录
        var hasStartCheck = false; //
        var log = window.logInfo ? window.logInfo.bind(window) : function() {};

        function checkErr(_o) {
            try{
                // 格式化
                _o.iSceneId    = (_o.iSceneId    || 0) + "";
                _o.iUIArea     = (_o.iUIArea     || 0) + "";
                _o.iPositionId = (_o.iPositionId || 0) + "";
                _o.iActionId   = (_o.iActionId   || 0) + "";
                _o.iOpType     = (_o.iOpType     || 0) + "";

                // 漏报检查
                if (!hasStartCheck && _o.iActionId && _o.iActionId === 1) {
                    setTimeout(function() {
                        checkLeak();
                    }, 5000);
                    hasStartCheck = true;
                }

                // 1、错报检查
                if (!checkIllegal(_o)) {
                    console.log("11332 checkIllegal fail: ", _o);
                    return 1;
                }

                // 2、重复报检查
                if (checkRepeat(_o)) {
                    console.log("11332 checkRepeat fail: ", _o);
                    return 2;
                }

                addReportItem2History(_o);

                
                return 0;
            }catch(e){
                return 99;
            }
        }

        // 错误检查
        // return false 表示异常
        // return true  表示合法
        function checkIllegal(_o) {
            var list = window.RPT_DATA_TO_CHECK || [];
            if (list.length === 0) {
                return true;
            }

            //  "scenceid"    : "string",
            //  "iUIArea"     : "string",
            //  "iPositionID" : "range|list",
            //  "iActionId"   : "range|list",
            //  "Optype"      : "range|list",
            for (var i = 0, len = list.length; i < len; i++) {
                if(parseInt(_o.iActionId) >= 1000) return true; // 开发自定义的上报，直接pass

                if (list[i][0] === _o.iUIArea + "") {
                    // 检查iPositionID iActionId iOpType
                    // 任何一个不符合，则跳过，继续匹配下一个规则
                    if( !checkValue(_o.iPositionId , list[i][1]) ) continue; // 非法则继续匹配下一个

                    // if( !checkValue(_o.iActionId   , list[i][2]) ) continue; 
                    var allowedActionidList = [2, 22, 23, 40, 44, 45, 47, 54, 55, 58, 59, 71, 74, 75, 76, 77, 78, 79];
                    if(allowedActionidList.indexOf(parseInt(_o.iActionId)) === -1 && !checkValue(_o.iActionId   , list[i][2])){ // 录入同学表示actionid只要在合法范围接口。
                        continue;
                    } 

                    // 影响不大，数据侧要求不检查
                    // if( !checkValue(_o.iOpType     , list[i][3]) ) continue; 


                    // 检查必报项是否为空
                    if( !checkRequired(_o          , list[i][6]) ) continue;

                    // 若11332协议字段位置变化，下面4、5下标要更改
                    _o.uniq   = list[i][4] === "1" ? true : false;
                    _o.isNeed = list[i][5] === "1" ? true : false;

                    // 都没问题，返回true
                    return true;

                }
            }

            return false;

        }

        /**
         * 检查数值是否在合法范围内
         *
         * @param  {string}  val       The value
         * @param  {object}  limitObj  可以是 区间range : [101, 999] 或 数组list : [22, 23, 40, 71] 或 单独的值
         * @return {boolean} { true : 合法  false : 非法 }
         */
        function checkValue(val, limitObj){
            var valInt = parseInt(val || 0), // 转成数字
                valStr = val + "";           // 转成字符串，数据控制系统的字符全部是字符串，所以要强制转换来做匹配
            if (limitObj.range) {
                if (parseInt(limitObj.range[0]) > valInt && parseInt(limitObj.range[1]) < valInt) {
                    return false;
                }
            } else if (limitObj.list) {
                if (limitObj.list.indexOf(valStr) === -1) {
                    return false;
                }
            } else if (limitObj !== valStr) {
                return false;
            }
            return true;
        }

        /**
         * 检查必报想
         *
         * @param      {object}   obj          即将上报的数据
         * @param      {object}   requiredObj  必报的列
         * @return     {boolean}  true: 正常  false: 失败
         */
        function checkRequired(obj, requiredList){
            for(var i in requiredList){
                if(requiredList[i] === "GameID" && !obj.sGameId){
                    return false;
                }
            }
            return true;
        }

        function addReportItem2History(_o) {

            //  "scenceid"    : "string",
            //  "iUIArea"     : "string",
            //  "iPositionID" : "range|list",
            //  "iActionId"   : "range|list",
            //  "Optype"      : "range|list",
            var item = [
                _o.iSceneId,
                _o.iUIArea,
                _o.iPositionId,
                _o.iActionId,
                _o.iOpType,
                _o.uniq,
                _o.isNeed
            ];
            reportHistoryList.push(item);
        }

        /**
         * 检查重复
         * reportHistoryList[i][5] = 1 表示该行只能报一次
         * @return     {boolean}  { true表示有重复，false表示没重复 }
         */
        function checkRepeat(_o) {
            for (var i = 0, len = reportHistoryList.length; i < len; i++) {
                if (_o.uniq + "" === "1" &&
                    reportHistoryList[i][0] === _o.iSceneId &&
                    reportHistoryList[i][1] === _o.iUIArea &&
                    reportHistoryList[i][2] === _o.iPositionId &&
                    reportHistoryList[i][3] === _o.iActionId &&
                    reportHistoryList[i][4] === _o.iOpType
                ) {
                    return true;
                }
            }

            return false;
        }



        // 第一个曝光上报的5秒后，检查漏报
        // 唯一上报的每个参数都不能是range或list，必须是唯一的值
        function checkLeak() {
            // return; // 暂时屏蔽
            var list = window.RPT_DATA_TO_CHECK || [];
            var leakList = [];
            for (var i in list) {
                if (list[i][5] + "" === "1") {
                    var isReported = false;
                    for (var j in reportHistoryList) {
                        if (reportHistoryList[i][0] === list[i].iSceneId &&
                            reportHistoryList[i][1] === list[i].iUIArea &&
                            reportHistoryList[i][2] === list[i].iPositionId &&
                            reportHistoryList[i][3] === list[i].iActionId &&
                            reportHistoryList[i][4] === list[i].iOpType
                        ) {
                            isReported = true;
                            break;
                        }
                    }

                    if (!isReported) {
                        leakList.push(list[i]);
                    }
                }
            }
            if (leakList.length > 0) {
                reportLeak(leakList);
                return false;
            }
            return true;

        }

        // 上报漏报
        function reportLeak(leakList) {
            // todo
            var cgi = "/cgi-bin/comm/reportlogerror";
            var list = [];
            for (var i in leakList) {
                list.push({
                    "scene_id"       : parseInt(leakList[i][0]),
                    "ui_area"        : parseInt(leakList[i][1]),
                    "position_id"    : parseInt(leakList[i][2]),
                    "action_id_list" : [ parseInt(leakList[i][3]) ],
                    "op_type_list"   : [ parseInt(leakList[i][4]) ],
                    "uniq"           : true,
                    "is_need"        : true
                })
            }

            var param = {
                method: 'POST',
                "leak": {
                    "scene_id"  : 24,
                    "url"       : encodeURIComponent(location.href.split("#")[0].replace(/(&|\?)(uin|pass_ticket|key)=[^&]+/g, '')),
                    "item_list" : list
                }
            };
            // 后台还没发
            xhrCallCgi(cgi, JSON.stringify(param), function(res) {});
        }

        exportData = checkErr;
    })(window, document);
}else{
    exportData = {};
}
export default exportData;
